import { Head } from "@inertiajs/react"

import { MainContainer } from "@/components/ui/container"
import { PageHeader } from "@/components/ui/headers"
import { StaffLayout } from "@/components/layouts/staff-layout"
import {
  CustomerLedger,
  type Customer,
  type LedgerEntry,
} from "@/features/staff/loyalty/customer-ledger"
import { t } from "@/lib/i18n"

/**
 * The restaurant's own customers.
 *
 * Every row on this screen belongs to this restaurant. A diner who eats
 * somewhere else has a separate row there that nothing here can reach, and the
 * screen says nothing about it — from this side, it does not exist.
 */

type Props = {
  customers: Customer[]
  recentEntries: LedgerEntry[]
  outstandingPoints: number
  timeZone: string
}

export default function StaffLocationManageCustomersIndex({
  customers,
  recentEntries,
  outstandingPoints,
  timeZone,
}: Props) {
  const title = t("ui.react.pages.staff.location.manage.customers.index.page_title")

  return (
    <>
      <Head title={title} />

      <MainContainer>
        <PageHeader
          title={title}
          description={t("ui.react.pages.staff.location.manage.customers.index.page_description")}
        />

        <CustomerLedger
          customers={customers}
          recentEntries={recentEntries}
          outstandingPoints={outstandingPoints}
          timeZone={timeZone}
        />
      </MainContainer>
    </>
  )
}

StaffLocationManageCustomersIndex.layout = (page: React.ReactNode) => (
  <StaffLayout>{page}</StaffLayout>
)
